import CenteredSpinner from './CenteredSpinner'

export default CenteredSpinner
